/* eslint-disable no-unused-expressions */
import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { progress } from '../animations';
import { viewport } from '../getViewport';

export const storyHeader = () => {
  const storyHeaderWrapper = $('.story-header__inner');

  if (storyHeaderWrapper) {
    const tl = gsap.timeline();
    const storyTop = $('.story-header__top', storyHeaderWrapper);
    const video = $('.story-header__video', storyHeaderWrapper);
    const storyBottom = $('.story-header__bottom-content', storyHeaderWrapper);
    const paragraphs = $$('.story-header__paragraph', storyHeaderWrapper);

    const setVideoSrc = () => {
      const language = $('html').getAttribute('lang');

      if (language) {
        const src = $$('source', video);
        const assetUrl =
          'https://www.helmholtz.de/_assets/4e25df9997048755bbe02d1d413588ee/Frontend/Build/assets/videos/';
        const videoFiles = {
          desktopWebm: 'story-header.webm',
          desktopMp4: 'story-header.mp4',
          mobileWebm: 'story-header-768.webm',
          mobileMp4: 'story-header-768.mp4',
          desktopWebmEn: 'story-header-en.webm',
          desktopMp4En: 'story-header-en.mp4',
          mobileWebmEn: 'story-header-768-en.webm',
          mobileMp4En: 'story-header-768-en.mp4',
        };

        if (language === 'de-DE') {
          setTimeout(function () {
            video.pause();
            viewport.isDesktop
              ? src[0].setAttribute('src', assetUrl + videoFiles.desktopWebm)
              : viewport.isMobile
              ? src[0].setAttribute('src', assetUrl + videoFiles.mobileWebm)
              : null;
            viewport.isDesktop
              ? src[1].setAttribute('src', assetUrl + videoFiles.desktopMp4)
              : viewport.isMobile
              ? src[1].setAttribute('src', assetUrl + videoFiles.mobileMp4)
              : null;
            video.load();
            video.play();
          }, 0);
        }

        if (language === 'en-GB') {
          setTimeout(function () {
            video.pause();
            viewport.isDesktop
              ? src[0].setAttribute('src', assetUrl + videoFiles.desktopWebmEn)
              : viewport.isMobile
              ? src[0].setAttribute('src', assetUrl + videoFiles.mobileWebmEn)
              : null;
            viewport.isDesktop
              ? src[1].setAttribute('src', assetUrl + videoFiles.desktopMp4En)
              : viewport.isMobile
              ? src[1].setAttribute('src', assetUrl + videoFiles.mobileMp4En)
              : null;
            video.load();
            video.play();
          }, 0);
        }
      }
    };

    setVideoSrc();

    const setHeaderHeight = () => {
      video.addEventListener('loadeddata', () => {
        const headerHeight = storyTop.offsetHeight;
        storyHeaderWrapper.setAttribute(
          'style',
          `max-height:${headerHeight}px;`
        );
      });
    };

    setHeaderHeight();

    gsap.set(storyBottom, {
      yPercent: viewport.isDesktop
        ? '50'
        : viewport.isTablet
        ? '0.5'
        : viewport.isMobile
        ? '50'
        : '',
    });

    tl.to(storyTop, {
      scale: viewport.isDesktop
        ? '0.5'
        : viewport.isTablet
        ? '0.5'
        : viewport.isMobile
        ? '0.8'
        : '',
      transformOrigin: 'center top',
    });

    tl.to(
      storyBottom,
      {
        yPercent: viewport.isDesktop
          ? '-200'
          : viewport.isTablet
          ? '-100'
          : viewport.isMobile
          ? '-110'
          : '',
      },
      '<'
    );

    ScrollTrigger.create({
      animation: tl,
      trigger: storyHeaderWrapper,
      start: () =>
        viewport.isDesktop
          ? '0'
          : viewport.isTablet
          ? '-89'
          : viewport.isMobile
          ? '-81'
          : '',
      end: () => 'bottom top',
      toggleActions: 'play pause resume reset',
      scrub: 1,
      invalidateOnRefresh: true,
      onUpdate: self => progress(self),
      onLeave: () => {
        video.pause();
      },
      onEnterBack: () => {
        video.play();
      },
    });

    if (paragraphs.length) {
      paragraphs.forEach(paragraph => {
        // eslint-disable-next-line no-unused-vars
        const splitLines = SplitText.create(paragraph, {
          type: 'lines',
          tag: 'span',
          linesClass: 'story-header__line',
        });

        // splitLines.lines.forEach(line => {
        //   gsap.set(line, { yPercent: 100 });
        // });
        //
        // const linesTimeline = gsap.timeline();
        //
        // linesTimeline.to(splitLines.lines, {
        //   yPercent: 0,
        //   stagger: 0.2,
        //   alpha: 1,
        // });
        //
        // ScrollTrigger.create({
        //   animation: linesTimeline,
        //   trigger: paragraph,
        //   markers: true,
        //   start: () => 'top bottom',
        //   end: () => 'bottom center',
        //   toggleActions: 'play pause resume reverse',
        // });
      });
    }
  }
};
